import { definitions } from '@luxuryescapes/contract-svc-promo';

type VoucherCondition = definitions['VoucherConditionV1'];

/**
 * The conditions grid assigns temporary IDs to new rows so MUI DataGrid can
 * identify them. Retain only IDs returned by the API for an existing
 * condition; omit temporary IDs and legacy conditions that have no ID.
 */
export function serializeVoucherConditions(
  conditions: Array<VoucherCondition>,
  existingConditionIds: ReadonlySet<string>,
): Array<VoucherCondition> {
  return conditions.map(({ id_voucher_condition, ...condition }) => {
    if (id_voucher_condition && existingConditionIds.has(id_voucher_condition)) {
      return { ...condition, id_voucher_condition };
    }

    return condition;
  });
}
